import { z } from 'zod';
import { ResourceType } from '../custom-field-assignments/index.js';
import { FieldType } from '../custom-fields/index.js';
import { parentConditionValueSchema } from '../custom-fields/parent-condition-value.js';
// Custom Field Instance schemas
export const customFieldInstanceResponseSchema = z.object({
    id: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
    resourceType: z.enum(ResourceType),
    resourceId: z.number(),
    name: z.string(),
    description: z.string().optional(),
    type: z.enum(FieldType),
    options: z.array(z.unknown()),
    required: z.boolean(),
    customFieldId: z.number(),
    value: z.unknown(),
    parentConditionInstanceId: z.number().nullable().optional(),
    parentConditionInstanceValue: parentConditionValueSchema.nullable().optional(),
    customField: z.object({
        id: z.number(),
        name: z.string(),
        description: z.string().optional(),
        type: z.enum(FieldType),
        status: z.string(),
    }),
    order: z.number(),
});
